module.exports = __webpack_public_path__ + "img/kbz.94e7e1b9.png";